/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCloseSmallThin({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M17.46 6.54a.65.65 0 0 1 0 .92L12.918 12l4.54 4.54a.65.65 0 1 1-.919.92L12 12.92l-4.54 4.54a.65.65 0 1 1-.92-.92L11.08 12 6.54 7.46a.65.65 0 0 1 .92-.92L12 11.08l4.54-4.54a.65.65 0 0 1 .92 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCloseSmallThin;
